export const APP = {
  NAME: 'Instrumental Health',
  TAGLINE: 'Bridging Traditional Healing & Modern Science',
  DESCRIPTION:
    'A premium wellness platform offering herbal medicine consultations, scans, courses, and natural health products.',
  AUTHOR: 'Kandake Makonnen',
  BUILT_BY: 'Zhuwa Africa Limited',
  CONTACT_EMAIL: 'instrumentalhealth.inquiry@gmail.com',
} as const

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const
